<template>
  <div>
    <slide-x-left-transition :duration="{enter: 600, leave: 10}">
      <div v-if="!desc.description">
        <div class="input">
          <i class="material-icons">search</i>
          <input id="search" class="input2" type="search" v-model="search" placeholder="Job suchen">
          <i id="clear" @click="search=''" class="material-icons">clear</i>
        </div>
        <fade-transition group tag="ul" id="cG" :duration="{enter: 300, leave: 300}">
          <li v-for="(cat,i) in groups" :key="'cat' + i" class="category">
            <div>
              <div class="input">
                <i
                  @click="cat.show = !cat.show"
                  :class="['material-icons',{opened: cat.show || search != ''},'cursor']"
                >expand_more</i>
                <span
                  class="cursor"
                  @click="cat.show = !cat.show"
                >{{cat.name}} ({{filteredItems(groups[i]).length}})</span>
              </div>
              <collapse-transition>
                <ul v-if="cat.show || search.length > 0 " class="job-container">
                  <div v-if="filteredItems(groups[i]).length != 0">
                    <li
                      @click="createDescription(job)"
                      v-for="(job, o) in filteredItems(groups[i])"
                      :key="'job'+o"
                      class="job"
                    >{{job.name}}</li>
                  </div>
                  <div v-else>
                    <span style="opacity: 0.75; margin-left: 15px;">Hier wurde nichts gefunden</span>
                  </div>
                </ul>
              </collapse-transition>
            </div>
          </li>
        </fade-transition>
      </div>
    </slide-x-left-transition>
    <slide-x-right-transition :duration="{enter: 600, leave: 10}">
      <div v-if="desc.description">
        <div>
          <button @click="desc.description=false">Zurück</button>
          <h1>{{desc.name}}</h1>
          <div v-for="(data,i) in desc.desc" :key="'desc' + i">
            <h2 v-html="data.name"></h2>
            <span v-html="data.content"></span>
          </div>
          <button
            style="margin-top: 20px;"
            @click="desc.description=false; createWindow()"
            class="input2"
          >Bewerben</button>
        </div>
      </div>
    </slide-x-right-transition>
  </div>
</template>

<script>
import convert from "xml-js";
import { CollapseTransition } from "vue2-transitions";
import { FadeTransition } from "vue2-transitions";
import { SlideXLeftTransition } from "vue2-transitions";
import { SlideXRightTransition } from "vue2-transitions";

export default {
  data() {
    return {
      xml: "",
      search: "",
      desc: {
        name: "",
        description: false,
        desc: [],
        url: ""
      },
      ihk_data: {},
      groups: []
    };
  },
  components: {
    CollapseTransition,
    FadeTransition,
    SlideXLeftTransition,
    SlideXRightTransition
  },
  methods: {
    checkProps(parent, propsArray) {
      // jobs[u].PositionLocation.Address.CityName._cdata
      try {
        return propsArray.reduce((item, index) => {
          return item[index];
        }, parent);
      } catch (error) {
        return '';
      }
    },
    compareValues(key, order) {
      return function(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0;
        }

        const letA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const letB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (letA > letB) {
          comparison = 1;
        } else if (letA < letB) {
          comparison = -1;
        }
        return order == "desc" ? comparison * -1 : comparison;
      };
    },
    httpGetXml() {
      let request = new XMLHttpRequest();
      request.open("GET", "stellenboerse.xml", false);
      request.send();

      if (request.status === 200) {
        this.xml = request.responseText;
      }
    },
    createWindow() {
      let strWindowFeatures = "status=yes,scrollbars=yes,location=yes";
      let URL = this.desc.url;
      window.open(URL, "_blank", strWindowFeatures);
    },
    xmlToJs() {
      this.ihk_data = convert.xml2js(this.xml, { compact: true, spaces: 4 });
    },
    filteredItems(group) {
      let jobs = group.jobs;
      // if there is no filter, return everything
      if (!this.search) return jobs;

      // setup the filter function
      let searchValue = this.search.toLowerCase().trim();
      let filter = jobs => jobs.name.toLowerCase().includes(searchValue);

      return jobs.filter(filter);
    },
    createDescription(job) {
      this.desc.description = true;
      this.desc.desc = job.desc;
      this.desc.name = job.name;
      this.desc.url = job.url_app;
    }
  },
  mounted() {
    this.httpGetXml();
    this.xmlToJs();

    let result = [];
    //Daten sinnvoll umstrukturieren
    const jobs = this["ihk_data"]["PositionOpening"]["PositionProfile"];

    let groups = [];

    // Über die Jobs iterieren
    // Index i
    for (let i = 0; i < jobs.length; i++) {

      if (jobs[i].GroupingInformation.Group === undefined) {
        // Das ist wie nen Unfall: einfach weitergehen
        continue; 
      }

      let group;
      if(Array.isArray(jobs[i].GroupingInformation.Group)) {
        group = jobs[i].GroupingInformation.Group[0]._cdata;
      } else {
        group = jobs[i].GroupingInformation.Group._cdata;
      }

      let found = groups.findIndex(item => {
        return item.name === group;
      });
      // Gruppenzuordnung klären
      if (found === -1) {
        groups.push({
          name: group,
          show: false,
          jobs: []
        });
        
        found = groups.length-1;
      } 

      // Variablen von dem Objekt übernehmen
      let job = {
          name: jobs[i].PositionTitle._cdata,
          id: jobs[i].ID._text,
          url_app: jobs[i].PostingInstruction.ApplicationMethod.URI._text,
          desc: []
        };

   
      // Beschreibungselemente ziehen
      // di = Descrioption Index
      for (let di = 0; di < jobs[i].PositionFormattedDescription.length; di++) {
          // Name setzen
          if (typeof jobs[i].PositionFormattedDescription[di].Name !== "undefined") {            
            job.desc.push({
              name: jobs[i].PositionFormattedDescription[di].Name._cdata
            });
          }
          //Content setzen
          if (typeof jobs[i].PositionFormattedDescription[di].Content !== "undefined") {
            job.desc.push({
              content: jobs[i].PositionFormattedDescription[di].Content._cdata
            });
          }
      }

      // Standort / Anstellungsart
      job.desc.splice(
          1,  // an Position 1
          0,  // nix löschen
          {
            name: "<b>Standort</b>",
            content: this.checkProps(jobs[i], [
              "PositionLocation",
              "Address",
              "CityName",
              "_cdata"
            ])
          },
          {
            name: "<b>Anstellungsart</b>",
            content: this.checkProps(jobs[i], [
              "PositionPeriod",
              "StartDate",
              "FormattedDateTime",
              "_text"
            ])
          }
        );

       groups[found].jobs.push(job);

    }


    this.groups = groups;

  },
  beforeUpdate() {
    for (let i = 0; i < this.groups.length; i++) {
      this.groups[i].jobs.sort(this.compareValues("name"));
    }
  }
};
</script>   

<style scoped>
.job {
  display: list-item;
  margin-bottom: 10px;
  color: #2D76B2;
  cursor: pointer;
  user-select: none;
}
.job:hover {
  color: rgb(84, 126, 143);
  text-decoration: underline;
}
.opened {
  transform: rotate(-180deg);
}
#cG {
  margin-top: 10px;
}
i {
  text-align: center;
  padding: 10px;
  transition: all 0.25s;
  user-select: none;
}
.cursor {
  cursor: pointer;
  user-select: none;
}
#desc {
  font-weight: bold;
  display: block;
}
.job-container {
  list-style: none;
  width: 85%;
  margin-left: auto;
  margin-right: auto;
}
.category {
  font-size: 20px;
  display: block;
}
.input {
  display: flex;
  align-items: center;
}
.input2 {
  width: 100%;
  border: 2px solid grey;
  border-radius: 2px;
}
#select {
  height: 50%;
  margin-left: 5px;
  width: 25%;
}
#search {
  padding-left: 5px;
}
#clear:hover {
  transform: rotate(180deg);
}
.input2:focus {
  outline: none;
  border-color: rgb(179, 179, 179);
}
h2 {
  padding-top: 10px;
}
ul {
  padding: 0;
  margin: 0;
}
</style>
